function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C18.6289 0 24 5.37258 24 12L23.9962 12.305C23.8344 18.7929 18.5255 24 12 24L11.695 23.9962C5.20713 23.8344 0 18.5255 0 12L0.00379986 11.695C0.165607 5.20713 5.47454 0 12 0ZM18.2918 7.66519C17.9107 7.29876 17.292 7.29612 16.9121 7.6614L10 14.3077L7.09412 11.5136C6.70693 11.1413 6.09027 11.144 5.7082 11.5113L5.6918 11.5271C5.31071 11.8936 5.31126 12.4916 5.69523 12.8608L9.30477 16.3315C9.68723 16.6993 10.3095 16.7024 10.6913 16.3353L18.3087 9.01084C18.6902 8.64404 18.6903 8.04834 18.3082 7.68096L18.2918 7.66519Z",
  fill: "currentColor"
});

var SvgCheckCircle24 = function SvgCheckCircle24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle-24.4972e361.svg";
export { ForwardRef as ReactComponent };